import { render, staticRenderFns } from "./DataTableDocumentos.vue?vue&type=template&id=134095c3&scoped=true"
import script from "./DataTableDocumentos.vue?vue&type=script&lang=js"
export * from "./DataTableDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134095c3",
  null
  
)

export default component.exports